"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceAddressCms = void 0;
var ServiceAddressCms = /** @class */ (function () {
    function ServiceAddressCms() {
        this.heading = 'Service address';
    }
    return ServiceAddressCms;
}());
exports.ServiceAddressCms = ServiceAddressCms;
//# sourceMappingURL=ServiceAddress.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/panels/ScheduleInstallPanel/ServiceAddress/ServiceAddress.cms.js
// module id = 966
// module chunks = 8